import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Radio } from "antd";
import { TAULA, MAPA } from "../../constantsFormularis";
import { selecioTipusVisualitzacio } from "../../actions";
import { getTipusActiu } from "../../reducers";
import styles from "./VisualitzacioTipus.module.css";

const RadioGroup = Radio.Group;

class VisualitzacioTipus extends Component {
  constructor(props) {
    super(props);
    this.onClickTipus = this.onClickTipus.bind(this);
  }

  //  Event que es dispara quan es fa 'click' en un botó de periode
  //  @param event
  onClickTipus(event) {
    const tipusNou = event.target.value;
    const tipusActiu = this.props.tipusActiu ? this.props.tipusActiu : MAPA;

    if (tipusActiu !== tipusNou) {
      this.props.selecioTipusVisualitzacio(tipusNou);
      this.setState({
        value1: tipusNou
      });
    }
  }

  render() {
    const tipusActiu = this.props.tipusActiu ? this.props.tipusActiu : MAPA;
    return (
      <div
        style={{ marginTop: 16, marginLeft: 16, marginBottom: 30 }}
        className={styles.noDisplay}
      >
        <RadioGroup onChange={this.onClickTipus} defaultValue={tipusActiu}>
          <Radio.Button value={MAPA}>{MAPA}</Radio.Button>

          <Radio.Button value={TAULA}>{TAULA}</Radio.Button>
        </RadioGroup>
      </div>
    );
  }
}

VisualitzacioTipus.propTypes = {
  tipusActiu: PropTypes.string,
  selecioTipusVisualitzacio: PropTypes.func
};

const mapStateToProps = state => {
  return {
    tipusActiu: getTipusActiu(state)
  };
};

export default connect(mapStateToProps, { selecioTipusVisualitzacio })(
  VisualitzacioTipus
);
